console.log("Old Dragon 🐲");

// If using a TypeScript entrypoint file:
//   <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// First, so the agent is already filtering before Turbo and the controllers get
// a chance to throw anything.
import "../browser_error_filter.js";

import "@hotwired/turbo-rails";
import "@rails/activestorage";

import "./activestorage.js";
import "./turbopower.js";
import "pagy.mjs";
import "./register_service_worker.js";
import "../turbo_focus_guard.js";

// Application
import "../controllers/index.js";
import { startDiceSound } from "../dice/sound";

startDiceSound();
